import { db } from '../config/firebase';
import {
    collection,
    addDoc,
    deleteDoc,
    doc,
    getDocs,
    query,
    where
} from 'firebase/firestore';
import { Favorite } from '../types/favorite';

const COLLECTION_NAME = 'favorites';

export const favoriteService = {
    async getFavoritesByUserId(userId: string) {
        try {
            const q = query(
                collection(db, COLLECTION_NAME),
                where('userId', '==', userId)
            );
            const querySnapshot = await getDocs(q);
            return querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })) as Favorite[];
        } catch (error) {
            throw new Error('Không thể lấy danh sách yêu thích: ' + error);
        }
    },

    async addFavorite(favorite: Favorite) {
        try {
            const docRef = await addDoc(collection(db, COLLECTION_NAME), {
                ...favorite,
                createdAt: new Date()
            });
            return { id: docRef.id, ...favorite };
        } catch (error) {
            throw new Error('Không thể thêm vào yêu thích: ' + error);
        }
    },

    async deleteFavorite(id: string) {
        try {
            await deleteDoc(doc(db, COLLECTION_NAME, id));
        } catch (error) {
            throw new Error('Không thể xóa khỏi yêu thích: ' + error);
        }
    },

    async deleteFavoritesByUserId(userId: string) {
        try {
            const q = query(
                collection(db, COLLECTION_NAME),
                where('userId', '==', userId)
            );
            const querySnapshot = await getDocs(q);

            await Promise.all(
                querySnapshot.docs.map(doc => deleteDoc(doc.ref))
            );

            return true;
        } catch (error) {
            throw new Error('Could not delete user favorites: ' + error);
        }
    },

    async getUserFavorites(userId: string) {
        const q = query(
            collection(db, COLLECTION_NAME),
            where('userId', '==', userId)
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        })) as Favorite[];
    },

    async deleteFavoritesByProductId(productId: string) {
        try {
            console.log(`Removing favorites for product: ${productId}`);
            
            // Tìm và xóa tất cả favorites có coffeeId = productId
            // (trong trường hợp dụng cụ cà phê, có thể dùng coffeeId để lưu equipment ID)
            const q = query(
                collection(db, COLLECTION_NAME),
                where('coffeeId', '==', productId)
            );
            
            const querySnapshot = await getDocs(q);
            
            await Promise.all(
                querySnapshot.docs.map(doc => deleteDoc(doc.ref))
            );

            console.log(`Successfully removed ${querySnapshot.size} favorite records for product ${productId}`);
            return true;
        } catch (error) {
            console.error('Error deleting favorites by product ID:', error);
            throw new Error('Could not delete favorites: ' + error);
        }
    },
}; 